module.exports = __webpack_public_path__ + "static/media/magic_chess_union.eec53a02.png";